import { render, staticRenderFns } from "./AddNewAdmin.vue?vue&type=template&id=685975ea&scoped=true&"
import script from "./AddNewAdmin.vue?vue&type=script&lang=js&"
export * from "./AddNewAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAdmin.vue?vue&type=style&index=0&id=685975ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685975ea",
  null
  
)

export default component.exports